import ReactDom from 'react-dom';
import React from 'react'; // eslint-disable-line no-unused-vars
import ErrorBoundary from './ErrorBoundary'; // eslint-disable-line no-unused-vars
import * as uiInternal from '@servicenow/ui-internal';

const {noop} = uiInternal;
const helperNoop = Object.assign(noop, {
	dispatch: noop,
	updateState: noop,
	updateProperties: noop
});

/**
 * Renders a view using React
 * @method onStateChange
 * @private
 * @param {HTMLElement} element Element to append rendered React component to
 * @param {Function} Component React Component
 * @param {Object} [props = {}] Optional properties object
 * @param {Function} helpers.dispatch Function for dispatching actions
 * @param {Function} helpers.updateState Function for updating component state
 * @param {Function} helpers.updateProperties Function for updating component properties
 * @returns {Promise}
 */
export default async function onStateChange(element, Component, props = {}, helpers = helperNoop) {
	return await ReactDom.render(
		<ErrorBoundary helpers={helpers} element={element}>
			<Component {...props} dispatch={helpers} helpers={helpers} />
		</ErrorBoundary>,
		element
	);
}
